import type { ReactNode } from 'react';

export function Card({ title, children, action }: { title?: string; children: ReactNode; action?: ReactNode }) {
  return (
    <section className="bg-white rounded-card border border-slate-200 p-5">
      {(title || action) && (
        <header className="flex items-center justify-between mb-3">
          <h2 className="font-semibold">{title}</h2>
          {action}
        </header>
      )}
      {children}
    </section>
  );
}
